/**
 * Small formatters shared across pages. No dayjs / date-fns — these
 * are 5-line functions and shipping a date library to gate 5 lines
 * adds 30 KB to a console only one person opens.
 */

const SECOND = 1000;
const MINUTE = 60 * SECOND;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;
const WEEK = 7 * DAY;

export function relativeTime(epochMs: number, now = Date.now()): string {
  const diff = Math.max(0, now - epochMs);
  if (diff < MINUTE) return "just now";
  if (diff < HOUR) {
    const m = Math.floor(diff / MINUTE);
    return `${m}m ago`;
  }
  if (diff < DAY) {
    const h = Math.floor(diff / HOUR);
    return `${h}h ago`;
  }
  if (diff < WEEK) {
    const d = Math.floor(diff / DAY);
    return `${d}d ago`;
  }
  const w = Math.floor(diff / WEEK);
  return `${w}w ago`;
}

export function absoluteTime(epochMs: number): string {
  const d = new Date(epochMs);
  return d.toLocaleString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function shortDeviceId(deviceId: string): string {
  return deviceId.slice(0, 8);
}

export function formatNumber(n: number): string {
  return n.toLocaleString();
}
